const countrySwitcherForms = document.querySelectorAll("[data-country-selector]");
const CART_TOKEN_ENDPOINT = '/apps/abapp/customerCartToken';

var delete_cookie = function(name) {
    document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

var clear_metafield_token = function(customerGid) {
    if (!customerGid) {
        return Promise.resolve();
    }

    return fetch(CART_TOKEN_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: customerGid,
            token: null,
            date: new Date().toISOString()
        })
    }).then(response => {
        if (!response.ok) {
            return response.text().then(text => {
                throw new Error(text || 'Failed to clear cart token');
            });
        }
        return response;
    }).catch(error => {
        console.error('[persist] Unable to clear customer cart token:', error);
        throw error;
    });
};

var clear_cart_state = function(form) {
    delete_cookie('cart');
    try {
        localStorage.removeItem('pre_login_cart');
    } catch (error) {
        console.warn('[persist] Unable to clear pre_login_cart:', error);
    }

    if (form && form.dataset && form.dataset.customerGid) {
        return clear_metafield_token(form.dataset.customerGid);
    }

    return Promise.resolve();
};


const currentParams = window.location.search;
const currentHash = window.location.hash;

if (countrySwitcherForms && countrySwitcherForms.length) {
    countrySwitcherForms.forEach(form => {
        let countryCodeInput = form.querySelector('input[name="country_code"]');
        let returnToInput = form.querySelector('input[name="return_to"]');
        const buttons = form.querySelectorAll('button[name="country_code--button"]');
        buttons.forEach(button => {
            button.addEventListener("click", async () => {
                const baseHref = button.getAttribute('data-shop');
                
                const href = baseHref + (currentParams ? currentParams : '') + (currentHash ? currentHash : '');

                const isoCode = button.value;              
                if (isoCode !== Shopify.country) {
                    countryCodeInput.value = isoCode;
                    returnToInput.value = href;
                    delete_cookie('localization');
                    await clear_cart_state(form);
                    if (href.includes(Shopify.shop)) {
                        setTimeout(() => {
                            form.submit();
                        }, 200);
                    } else {
                        location.href = href;
                    }
                }
                
            });
        });
    });

}

// Apply order to all language selectors

const allLanguageSelectors = document.querySelectorAll('[id^="language_selector-"]');
  allLanguageSelectors.forEach(selector => {
    addOrderAttributes(selector);
  });

function addOrderAttributes(parentDiv) {
  const eligibleChildren = parentDiv.querySelectorAll(':scope > :not([data-is-glopal="true"])');

  eligibleChildren.forEach((child, index) => {
    child.setAttribute('style', `order: ${index + 1}`);
  });
}